import { useEffect, useMemo, useState } from "react"
import services from "../../services/services";
import { Urls } from "../../services/Urls";
import _ from "underscore";
import useAuthStore from "../../Store/authStore";


let myTempData = [];
let storeAllIds = [];
export const useCommon = () => {
    const permissions = useAuthStore(state => state.myPermission);
    const [projectOpts, setProjectOpts] = useState([]);
    const [grid, setgrid] = useState([]);
    const [allSprintList, setAllSprintList] = useState([]);
    const [bucketOpts, setBucketOpts] = useState([]);
    const checkPermission = (admins, buttonRef) => {
        if (buttonRef !== null) {
            if (!buttonRef?.current?.id) return;
            const currentRefId = JSON.parse(buttonRef.current.id);
            const buttn1 = currentRefId.data;
            const curentRef = buttonRef.current;
            const data = _.findWhere(permissions, { resource_key: buttn1 });
            if (!_.find(myTempData, {
                "is_active": false,
                "is_editable": false,
                'resource_key': buttonRef.current.id
            })) {
                myTempData.push({
                    "is_active": false,
                    "is_editable": false,
                    'resource_key': buttonRef.current.id
                });
                storeAllIds.push(JSON.parse(buttonRef.current.id));
            }
            if (!data) {
                curentRef.style.display = "none";
                return;
            }
            if (admins !== null && buttn1 && !_.isEmpty(permissions)) {
                if (data.hasOwnProperty('resource_key')) {
                    if (data.is_active && data.resource_key === buttn1 && !data.is_editable) {
                        curentRef.disabled = true;
                        curentRef.style.pointerEvents = 'none';
                        curentRef.style.opacity = 0.4;
                    } else if (data.is_editable && data.resource_key === buttn1) {
                        curentRef.disabled = false;
                    } else if (data.resource_key === buttn1 && !data.is_active) {
                        curentRef.style.display = "none";
                    }
                } else {
                    curentRef.style.display = "none";
                }
            }
        }
    }

    // get user project list
    const getUserProjects = async (flag) => {
        try {
            const payload = {
                "is_permission_auto_build": flag ? flag : false
            }
            const res = await services.getInvokeRemote("POST", Urls("GETUSERPROJECTS"), payload);
            if (res?.body?.data) {
                const data = res.body.data.userprojects
                const sortData = data?.sort((a, b) => a?.project_name?.localeCompare(b?.project_name));
                setProjectOpts(_.uniq(sortData, item => `${item.project_id}-${item.product_code}`));
            }
        } catch (error) {
            console.error("Error getting project list: ", error);
        }
    };

    // get project sprint list
    const getProjectSprints = async () => {
        try {
            const res = await services.getInvokeRemote("GET", Urls("GETPROJECTSPRINTS"));
            if (res?.body?.data) {
                const data = _.uniq(res.body.data.projectsprints?.sort((a, b) => { return b.sprint_completed_date - a.sprint_completed_date }), "sprint_id")
                const nullData = data?.filter((item) => item.sprint_completed_date === null);
                const notNullData = data?.filter((item) => item.sprint_completed_date !== null);
                setAllSprintList(nullData?.concat(notNullData))
            }
        } catch (error) {
            console.error("Error getting Sprints list: ", error);
        }
    }

    // get bucket all list or project wise
    const getBucketList = async (filterValues, setFilterValues, key, values, reset) => {
        const payload = {
            "project_ids": _.pluck(filterValues?.projects, 'project_id')?.toString()
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('GETBUCKETLIST'), payload);
            const currentDate = new Date();
            setBucketOpts(_.sortBy(_.uniq(res.body.data.bucket_status, (item) => item.bucket_id), (item) => new Date(item.bucket_enddate) <= currentDate ? 1 : -1));
            let buckets = [];
            if (key !== 'is_unique') {
                filterValues?.buckets?.forEach((item) => {
                    if (!_.isEmpty(_.findWhere(res.body.data.bucket_status, { bucket_id: item.bucket_id }))) {
                        buckets.push(item);
                    }
                })
                setFilterValues((prev) => ({ ...prev, buckets: buckets }));
            } else {
                values?.forEach((item) => {
                    if (!_.isEmpty(_.findWhere(res.body.data.bucket_status, { bucket_id: item.bucket_id }))) {
                        if (reset === 'is_reset') {
                            const data = _.findWhere(res.body.data.bucket_status, { bucket_id: values?.[0].bucket_id })
                            buckets.push(data);
                        } else {
                            buckets.push(item);
                        }
                    }
                    // setFilterValues(buckets)
                    setFilterValues((prev) => ({ ...prev, buckets: buckets }));
                })
                return buckets;
            }
        }
        catch (error) {
            console.error(error, "error");
        }
    }

    // handle the sprints based on project selection
    const handleSprintChange = (filterValues, setFilterValues, setSprintOpts, key, projects) => {
        if (!_.isEmpty(allSprintList)) {
            let sprintData = [];
            const projectIds = _.pluck(filterValues?.projects || projects, "project_id");
            if (!_.isEmpty(projectIds)) {
                projectIds?.forEach((id) => {
                    const data = _.filter(allSprintList, { project_id: id });
                    if (_.isEmpty(_.findWhere(sprintData, data))) {
                        sprintData = sprintData.concat(data);
                    }
                })
            } else {
                sprintData = allSprintList;
            }
            sprintData = sprintData.sort((a, b) => { return b.sprint_completed_date - a.sprint_completed_date });
            const nullData = sprintData?.filter((item) => item.sprint_completed_date === null);
            const notNullData = sprintData?.filter((item) => item.sprint_completed_date !== null);
            setSprintOpts(nullData.concat(notNullData));
            const sprints = []
            filterValues?.sprints?.forEach((data) => {
                if (!_.isEmpty(_.findWhere(sprintData, { sprint_id: data.sprint_id }))) {
                    sprints.push(data);
                }
                setFilterValues((prev) => ({ ...prev, sprints: sprints }));
            })
        }
    }


    const onSortChanged = (gridRef) => {
        const gridApi = gridRef.current.api;
        if (gridApi) {
            const allRows = [];
            gridApi.getModel().forEachNode((node) => {
                allRows.push(node.data); // Capture all rows, even if hidden by filters or pagination
            });
            //   Get the rows in the sorted order
            const sortedRows = [];
            gridApi.getModel().forEachNodeAfterFilterAndSort((node) => {
                sortedRows.push(node.data); // Capture rows in the sorted order
            });
            setgrid([...sortedRows])
        } else {
            console.error("Grid API is not initialized yet.");
        }
    };

    const handleValidation = async (key, email, setState) => {
        if (email?.trim() === '') {
            key === 'sign_up' && setState("Please enter email/employee code!")
            return false;
        }
        else if (email?.trim()?.includes("@") || email?.trim()?.includes(".")) {
            var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!regex.test(email.trim())) {
                key === 'sign_up' && setState("Invalid Email Address")
                return false;
            } else {
                key === 'sign_up' && setState(" ")
                return true;
            }
        }
        return false
    }

    // check permission for ag grid column
    const getValuePermission = (key) => {
        const obj = _.findWhere(permissions, { resource_key: key });
        if (!_.isEmpty(obj)) {
            if (!obj.is_active) {
                return true;
            }
            else {
                return false;
            }
        } else {
            return true
        }

    }

    const useDebounce = (value, delay) => {
        const [debouncedValue, setDebouncedValue] = useState(value);
        useEffect(() => {
            const handler = setTimeout(() => setDebouncedValue(value), delay);
            return () => clearTimeout(handler);
        }, [value, delay]);

        return debouncedValue;
    };

    return useMemo(() => ({
        getValuePermission,
        checkPermission, projectOpts, getUserProjects, getProjectSprints, allSprintList, getBucketList, bucketOpts, handleSprintChange, onSortChanged, grid, handleValidation, useDebounce
    }), [getValuePermission, checkPermission, projectOpts, getUserProjects, getProjectSprints, allSprintList, getBucketList, bucketOpts, handleSprintChange, onSortChanged, grid, handleValidation, useDebounce])
}